import { zodResolver } from "@hookform/resolvers/zod/dist/zod";
import { Box, Grid } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useLoader } from "../../../../hooks/useLoader";
import { useSubmitOperacion } from '../../hooks/useSubmitOperacion';
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema";
import { HttpCapitalMarkets } from "./api/httpCapitalMarkets";
import SeccionCapitalMarketsDatosOperacion from "./components/SeccionCapitalMarketsDatosOperacion";
import SeccionCapitalMarketsDetalleNuevo from "./components/SeccionCapitalMarketsDetalleNuevo";
import { OperacionCapitalMarketsFields } from "./types/fields";
import {
  FormOperacionCapitalMarkets, FormOperacionCapitalMarketsDetalle,
  schemaFormOperacionCapitalMarkets
} from "./types/types";

type NuevoSistemaCapitalMarketsProps = {
  codSistemaPrincipal: number
}

function NuevoSistemaCapitalMarkets(props: NuevoSistemaCapitalMarketsProps) {
  const { submitOperacion } = useSubmitOperacion();
  const { setSendPromise } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  const [detalleProvisional, setDetalleProvisional] = useState<FormOperacionCapitalMarketsDetalle>()

  const formMethods = useForm<FormOperacionCapitalMarkets>({
    resolver: zodResolver(schemaFormOperacionCapitalMarkets),
    defaultValues: {
      [OperacionCapitalMarketsFields.CodPais]: props.codSistemaPrincipal,
      [OperacionCapitalMarketsFields.EmisorPreAprobado]: false,
      [OperacionCapitalMarketsFields.SectorPrivado]: false,
      [OperacionCapitalMarketsFields.Underwriting]: false,
      [OperacionCapitalMarketsFields.SuperaLimitesUnderwriting]: 'No',
      [OperacionCapitalMarketsFields.Limites]: null,
    }
  })

  const alCrearOperacionCapitalMarkets = useCallback((data: FormOperacionCapitalMarkets, selected: number) => {
    if (!detalleProvisional) {
      toast.error('Debe cargar el detalle para enviar la operación.');
      
      return;
    }

    const payload = {
      ...data,
      [OperacionCapitalMarketsFields.Limites]: data[OperacionCapitalMarketsFields.Limites] || null,
      [OperacionCapitalMarketsFields.Detalle]: detalleProvisional,
      [OperacionCapitalMarketsFields.BitEnvio]: selected !== 1,
    };

    submitOperacion(payload, {
      apiCall: HttpCapitalMarkets.post,
      codSistemaPrincipal: props.codSistemaPrincipal,
      successMessage: 'Guardado correctamente.',
    });
  }, [detalleProvisional, props.codSistemaPrincipal, submitOperacion]);

  useEffect(() => {
    let onSend = () => console.log('on send test')

    onSend = () => formMethods.handleSubmit(data => alCrearOperacionCapitalMarkets(data, 2))

    setSendPromise(onSend)
    console.log(onSend)
  }, [formMethods, alCrearOperacionCapitalMarkets])

  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SeccionCapitalMarketsDatosOperacion
            formMethods={formMethods}
            codSistemaPrincipal={props.codSistemaPrincipal}
            nuevo
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionCapitalMarketsDetalleNuevo
            codPais={props.codSistemaPrincipal}
            detalleProvisional={detalleProvisional}
            setDetalleProvisional={setDetalleProvisional} />
        </Grid>
      </Grid>

    </Box>
  );
}

export default NuevoSistemaCapitalMarkets;